import React, { useContext } from 'react';
import { Link } from 'react-router-dom';

import UserContext from 'contexts/UserContext';
import Icon from 'components/Icon';

const Blank = ({ gradeId, blank, handleModal }) => {
	// Use user's context
	const { handleUser } = useContext(UserContext);

	// Handle student's blank removal
	// @event: object | native onClick event
	const onSelect = event => {
		event.preventDefault();
		handleModal();
		handleUser({
			type: 'ON_SELECT_BLANK_STUDENT',
			payload: {
				gradeId,
				courses: blank.courses
			}
		});
	};

	return (
		<div className="course">
			<div className="course__information">
				<Link to={`/blanks/${blank.id}`} className="course__title">
					{blank.title}
					<br />
					<small>Moduļi ({blank.courses?.length})</small>
				</Link>
			</div>

			<Icon
				icon="add"
				size="lg"
				className="course__add"
				onClick={onSelect}
			/>
		</div>
	);
};

export default Blank;